<div class="title">
  <div class="title-close-button-wrapper">
    <button cdkFocusInitial mat-dialog-close>
      <i class="fal fa-times-circle"></i>
    </button>
  </div>
  <h2 class="mat-primary">{{ 'dashboard:Storage time and delay' | i18next }}</h2>
</div>
<div class="dialog-content">
  <div class="label">{{ 'dashboard:Country' | i18next }}</div>
  <ng-select [items]="storageInfo" bindLabel="country" bindValue="id" class="select" [(ngModel)]="selectedStorageId" (change)="setCountry($event)" [searchable]="false">
</ng-select>
  <div class="label">{{ 'dashboard:Customer Key' | i18next }}</div>
  <div class="data">{{selected?.customerKey}}</div>
  <div class="label">{{ 'dashboard:Delay(Minutes)' | i18next }}</div>
  <div class="data">{{selected?.minuteDelay}}</div>
  <div class="label">{{ 'dashboard:Auto-update (on/off)' | i18next }}</div>
  <div class="data">{{selected?.autoupdatedata}}</div>
  <div class="label">{{ 'dashboard:Days To Store' | i18next }}</div>
  <div class="data">{{selected?.daysToStore}}</div>
  <ng-container *ngIf="selected?.daysToStoreAgent != null">
    <div class="label">{{ 'dashboard:Days To Store Agent statistics' | i18next }}</div>
    <div class="data">{{selected?.daysToStoreAgent}}</div>
  </ng-container>
</div>
